import { SVGProps } from 'react';

const Learn = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M11.636 2.345a.75.75 0 0 1 .728 0l5.418 3.01a.75.75 0 0 1-.728 1.311l-5.055-2.809L4.543 8 12 12.142l8.636-4.797A.75.75 0 0 1 21.75 8v3a.75.75 0 0 1-.386.655l-9 5a.75.75 0 0 1-.728 0L3.75 12.273v1.286L12 18.142l8.636-4.797A.75.75 0 0 1 21.75 14v3a.75.75 0 0 1-.386.655l-9 5a.75.75 0 0 1-.728 0l-9-5a.75.75 0 1 1 .728-1.31L12 21.142l8.25-4.583v-1.286l-7.886 4.382a.75.75 0 0 1-.728 0l-9-5A.75.75 0 0 1 2.25 14v-3a.75.75 0 0 1 1.114-.655L12 15.142l8.25-4.583V9.273l-7.886 4.382a.75.75 0 0 1-.728 0l-9-5a.75.75 0 0 1 0-1.31l9-5Z"
    />
  </svg>
);

export default Learn;
